import { render, staticRenderFns } from "./AjaxLogin.vue?vue&type=template&id=00d1d9f4"
import script from "./AjaxLogin.vue?vue&type=script&lang=js"
export * from "./AjaxLogin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports